import React, { useState, useEffect, useRef } from "react";
import styles from "./courseFilter.module.scss"; // Adjust the import path as needed
import CourseCardSmall from "components/studentcoursecardsm";
import { CourseServices } from "services/courses";
import Pagination from "components/pagination/pagination";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

const CourseFilter = () => {
  const [studentDetails, setStudentDetails] = useState([]);
  console.log(studentDetails, "student");

  useEffect(() => {
    getAllStudentsCourse();
  }, []);

  const getAllStudentsCourse = async () => {
    try {
      const response = await CourseServices.fetchStudentCourses();
      console.log("fetch courses", response);
      if (response.data.status === "success") {
        const res = response.data.data.details;
        setStudentDetails(res?.rows);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);

  const PageSize = 6;
  const firstPageIndex = (currentPage - 1) * PageSize;
  const lastPageIndex = firstPageIndex + PageSize;
  const currentTableData = studentDetails?.slice(firstPageIndex, lastPageIndex);
  console.log(currentTableData);
  const totalPages = Math.ceil(currentTableData?.length / PageSize);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // status change
  const [courseStatus, setCourseStatus] = useState("All Courses");
  const statuses = [
    "All Courses",
    "Featured",
    "Music",
    "Arts & Humanities",
    "Language",
    "Sciences",
    "Arts & Deisgn",
    "Business",
    "Accounting",
  ];

  const filteredCourses =
    courseStatus === "All Courses"
      ? currentTableData
      : currentTableData.filter((course) => course.subCategory === courseStatus);


      const scrollRef = useRef(null);

      const scroll = (direction) => {
        if (scrollRef.current) {
          const scrollAmount = 150; // Adjust scroll step if needed
          scrollRef.current.scrollBy({
            left: direction === "left" ? -scrollAmount : scrollAmount,
            behavior: "smooth",
          });
        }
      };

  return (
    <div className={styles.allcourses}>
     <div className="relative flex items-center justify-center mb-8">
      {/* Left Scroll Button */}
      <button
        onClick={() => scroll("left")}
        className="absolute left-0 p-2 bg-white shadow-md rounded-full hidden sm:flex"
      >
        <BsChevronLeft size={20} />
      </button>

      {/* Scrollable Statuses */}
      <div
        ref={scrollRef}
        className="flex overflow-x-auto scrollbar-hide gap-4 md:px-[100px] scroll-smooth"
      >
        {statuses.map((course) => (
          <button
            key={course}
            onClick={() => setCourseStatus(course)}
            className={`whitespace-nowrap md:text-[16px] transition-all hover:bg-primary font-ManropeSemibold md:leading-[24px] rounded-sm px-4 py-2 ${
              courseStatus === course
                ? "bg-primary text-secondary"
                : "text-secondary border-[1px] border-primary"
            }`}
          >
            {course}
          </button>
        ))}
      </div>

      {/* Right Scroll Button */}
      <button
        onClick={() => scroll("right")}
        className="absolute right-0 p-2 bg-white shadow-md rounded-full hidden sm:flex"
      >
        <BsChevronRight size={20} />
      </button>
    </div>
      <div className="w-full grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
        {filteredCourses?.map((student, index) => (
          <CourseCardSmall
            key={index}
            img={student?.thumbnail}
            duration={student?.duration}
            description={student?.description}
            title={student.title}
            text={student?.subject}
            tutor={student?.tutor}
          />
        ))}
      </div>
      <div className="w-full px-10 mt-10 ">
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default CourseFilter;
